import styled from "styled-components";

export const Container = styled.form`
  text-align: center;
  input {
    text-align: center;
    width: 2.7em;
  }
`;
